import React from 'react'
import Alert from '@mui/material/Alert';
import { SnackbarProvider, useSnackbar } from 'notistack';

const AlertPage = (props) => {
  const capitalize = (word)=> {
    const lower = word.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1); 
        }
  return (
    props.alert &&  <div>
    <Alert style={{zIndex:"1 !important", position:"fixed",top:"86px",width:"100vw",paddingTop:"0px",paddingBottom:"0px",fontSize:"12px", height:"30px"}} variant='filled' severity={`${props.alert.type}`}> <b>{capitalize(props.alert.type)}</b>: {props.alert.msg}</Alert>
    </div>
  )
}

export default AlertPage